import React from 'react';
import { fmtWhen } from './flagUtils';

const ACTIONS = {
  flagged: 'Flagged for correction', email_sent: 'Email sent to Case Manager', email_failed: 'Email could not be sent',
  email_skipped: 'Email skipped', field_changed: 'Changed review fields', status_changed: 'Changed status',
  corrections_submitted: 'Submitted corrections for management approval', comment: 'Added a comment',
  task_created: 'Task created', task_completed: 'Task completed', task_reopened: 'Task reopened', corrections_applied: 'Corrections saved to the Caseload Review', case_note_edited: 'Edited the case note',
  ai_summary_regenerated: 'AI summary regenerated', ai_summary_regeneration_failed: 'AI summary could not be regenerated',
  follow_up_summary_generated: 'Generated AI follow-up summary', approved: 'Approved and resolved', returned: 'Returned for correction',
};
const show = (v) => (Array.isArray(v) ? v.join(', ') : v) || '(blank)';

export const FlagHistory = ({ history }) => (
  <ol className="space-y-2" data-testid="flag-history">
    {[...(history || [])].reverse().map((h) => (
      <li key={h.id} className="text-xs border-l-2 border-muted pl-3" data-testid="flag-history-entry">
        <div className="flex flex-wrap gap-x-2">
          <span className="font-medium">{h.action === 'email_sent' && h.email_purpose === 'submitted' ? 'Email sent to Management' : (ACTIONS[h.action] || h.action)}</span>
          {h.status_to && h.action !== 'flagged' && <span>{h.status_from ? `${h.status_from} → ` : ''}{h.status_to}</span>}
        </div>
        <div className="text-muted-foreground">{h.by_name}{h.impersonator_name ? ` (signed in as, by ${h.impersonator_name})` : ''} · {fmtWhen(h.at)}</div>
        {(h.changes || []).map((c) => <div key={c.field} className="line-clamp-3">{c.label}: {show(c.old)} → {show(c.new)}</div>)}
        {h.email_to && <div className="text-muted-foreground">To {h.email_to}{h.email_cc ? `, copy ${h.email_cc.join(', ')}` : ''}</div>}
        {h.comment && <div className="whitespace-pre-wrap mt-0.5">&ldquo;{h.comment}&rdquo;</div>}
      </li>
    ))}
  </ol>
);
